/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingImageWithZoomQueryResponse, GetDrawingImageWithZoomPathParams, GetDrawingImageWithZoom422 } from "../models/drawingClient/GetDrawingImageWithZoom";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingImageWithZoomUrl(project_uuid: GetDrawingImageWithZoomPathParams["project_uuid"], file_uuid: GetDrawingImageWithZoomPathParams["file_uuid"], zoom_level: GetDrawingImageWithZoomPathParams["zoom_level"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/img/zoom/${zoom_level}` as const }  
  return res
}

/**
 * @description Returns an image which is represented as a dataurl containing a PNG file of the drawing with the specified zoom level.
 * @summary Get an image of a drawing with a specific zoom level
 * {@link /v1/drawings/:project_uuid/:file_uuid/img/zoom/:zoom_level}
 */
export async function getDrawingImageWithZoom(project_uuid: GetDrawingImageWithZoomPathParams["project_uuid"], file_uuid: GetDrawingImageWithZoomPathParams["file_uuid"], zoom_level: GetDrawingImageWithZoomPathParams["zoom_level"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingImageWithZoomQueryResponse, ResponseErrorConfig<GetDrawingImageWithZoom422>, unknown>({ method : "GET", url : getGetDrawingImageWithZoomUrl(project_uuid, file_uuid, zoom_level).url.toString(), ... requestConfig })  
  return res.data
}